<template>
  <v-col class="grow">
    <v-btn aria-label="Social Site" rel="noopener" data-cursor-target="center center" icon :href="block.url" class="social-link" v-for="(block, index) in data" :key="index" target="_blank">
      {{block._repeaterType === 'Facebook' ? 'Fb' : null}}
      {{block._repeaterType === 'Instagram' ? 'Ig' : null}}
      {{block._repeaterType === 'Website' ? 'Ws' : null}}
      <!-- <FacebookIcon v-if="block._repeaterType === 'Facebook'"/>
      <InstagramIcon v-if="block._repeaterType === 'Instagram'"/>
      <WebsiteIcon v-if="block._repeaterType === 'Website'"/> -->
    </v-btn>
  </v-col>
</template>

<script>

// import FacebookIcon from '@/assets/img/facebook-icon.svg'
// import InstagramIcon from '@/assets/img/instagram-icon.svg'
// import WebsiteIcon from '@/assets/img/world-icon.svg'

export default {
  name: 'SocialRepeater',
  components: {
    // FacebookIcon,
    // InstagramIcon,
    // WebsiteIcon
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>

.social-link {
  position: relative;
  display: inline-block;
  // width: 20px;
  transition: color 1s $ease-out-expo;

  &:hover {
    color: #e00;
  }
}

path {
  fill: currentColor !important;
}

path[stroke-width] {
  stroke: currentColor !important;
}

svg {
  color: map-get($shades, 'black');
  width: 18px;
  height: 18px;
}

</style>
